@let isMenuVisible = (visible$ | async) ?? true;
@let webshop = webshop$ | async;

<div [class.collapse]="!isMenuVisible" class="container">
  <div class="menu">
    <ul>
      <li>
        <a [routerLinkActive]="['is-active']" [routerLink]="'/' + Route.WEBSHOPS" class="menu-item" pRipple>
          <i class="pi pi-shopping-cart"></i>
          <span>{{ translation.components.webshop.listTitle }}</span>
        </a>
        @if (webshop && webshop.id) {
          <ul class="sub-menu">
<!--            <li>-->
<!--              <a [routerLinkActive]="['is-active']" [routerLink]="['/', Route.WEBSHOPS, webshop.id, 'orders']"-->
<!--                 class="menu-item" pRipple>-->
<!--                <i class="pi pi-shopping-bag"></i>-->
<!--                <span>{{ translation.components.webshop.tabOrders }}</span>-->
<!--              </a>-->
<!--            </li>-->
            <li>
              <a [routerLinkActive]="['is-active']" [routerLink]="['/', Route.WEBSHOPS, webshop.id, 'products']"
                 class="menu-item" pRipple>
                <i class="pi pi-box"></i>
                <span>{{ translation.components.webshop.tabProducts }}</span>
              </a>
            </li>
            <li>
              <a [routerLinkActive]="['is-active']" [routerLink]="['/', Route.WEBSHOPS, webshop.id, 'categories']"
                 class="menu-item" pRipple>
                <i class="pi pi-tags"></i>
                <span>{{ translation.components.webshop.tabCategories }}</span>
              </a>
            </li>
            <li>
              <a [routerLinkActive]="['is-active']" [routerLink]="['/', Route.WEBSHOPS, webshop.id, 'attributes']"
                 class="menu-item" pRipple>
                <i class="pi pi-list"></i>
                <span>{{ translation.components.webshop.tabAttributes }}</span>
              </a>
            </li>
            <li>
              <a [routerLinkActive]="['is-active']" [routerLink]="['/', Route.WEBSHOPS, webshop.id, 'pages']"
                 class="menu-item" pRipple>
                <i class="pi pi-file"></i>
                <span>{{ translation.menu.pages }}</span>
              </a>
            </li>
            <li>
              <a [routerLinkActive]="['is-active']"
                 [routerLink]="['/', Route.WEBSHOPS, webshop.id, 'settings']"
                 class="menu-item" pRipple>
                <i class="pi pi-cog"></i>
                <span>{{ translation.components.webshop.settingsTitle }}</span>
              </a>
            </li>
          </ul>
        }
      </li>
<!--      <li>-->
<!--        <a [routerLinkActive]="['is-active']" [routerLink]="'/' + Route.GALLERIES" class="menu-item" pRipple>-->
<!--          <i class="pi pi-images"></i>-->
<!--          <span>{{ translation.components.photoGallery.title }}</span>-->
<!--        </a>-->
<!--      </li>-->
      <li>
        <a [routerLinkActive]="['is-active']" [routerLink]="'/' + Route.CUSTOMERS" class="menu-item" pRipple>
          <i class="pi pi-users"></i>
          <span>{{ translation.components.user.listTitle }}</span>
        </a>
      </li>
      <li>
        <a [routerLinkActive]="['is-active']" [routerLink]="'/' + Route.COMPANIES" class="menu-item" pRipple>
          <i class="pi pi-building"></i>
          <span>{{ translation.components.company.listTitle }}</span>
        </a>
      </li>
    </ul>

  </div>
  @let me = me$ | async;
  <div class="profile-container">
    <hr/>
    <div [routerLink]="['/', Route.CUSTOMERS, me?.id]" class="profile" pRipple>
      <p-avatar [image]="me?.avatar" [icon]="!me?.avatar ? 'pi pi-user' : undefined" shape="circle"/>
      <span class="font-bold">{{ getUser(me) }}</span>
    </div>
  </div>
</div>
<div [class.collapse]="isMenuVisible" [class.small-menu]="!isMenuVisible">
  <app-button (onClick)="toggleMenu()" icon="pi pi-bars"/>
</div>
